var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11V7a5 5 0 019.9-1M5 11h14a2 2 0 012 2v7a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a2 2 0 012-2z",
    stroke: "#63656E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTcgMTFWNy4wMDAwM0M2Ljk5ODc1IDUuNzYwMDggNy40NTgyOCA0LjU2MzkgOC4yODkzNyAzLjY0MzdDOS4xMjA0NyAyLjcyMzUgMTAuMjYzOCAyLjE0NDkzIDExLjQ5NzUgMi4wMjAzMkMxMi43MzEyIDEuODk1NzEgMTMuOTY3MSAyLjIzMzkzIDE0Ljk2NTUgMi45NjkzNEMxNS45NjM4IDMuNzA0NzUgMTYuNjUzMyA0Ljc4NDg4IDE2LjkgNi4wMDAwM001IDExSDE5QzIwLjEwNDYgMTEgMjEgMTEuODk1NSAyMSAxM1YyMEMyMSAyMS4xMDQ2IDIwLjEwNDYgMjIgMTkgMjJINUMzLjg5NTQzIDIyIDMgMjEuMTA0NiAzIDIwVjEzQzMgMTEuODk1NSAzLjg5NTQzIDExIDUgMTFaIgogICAgICAgIHN0cm9rZT0iIzYzNjU2RSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8L3N2Zz4=";
export { SvgAccess as ReactComponent };